import Backbone from "backbone";
import AccountAddressTemplate from "../../../templates/AccountAddress.mustache"
import {pathname} from "../../common/others/Configuration";
import $ from "jquery";
import _ from "underscore";
import SharedDispatcher from "../../common/others/SharedDispatcher";

    /**
     * Address Book models
     */
    var DefaultAddressBillingModel = Backbone.Model.extend({
      // TODO move to account configuration
      urlRoot: pathname + "/account/api/v1/address-book/settings/default-billing/"
    });

    var DefaultAddressShippingModel = Backbone.Model.extend({
      // TODO move to account configuration
      urlRoot: pathname + "/account/api/v1/address-book/settings/default-shipping/",
    });

    var AddressBillingModel = Backbone.Model.extend({
      // TODO move to account configuration
      urlRoot: pathname + "/account/api/v1/address-book/default-billing/"
    });

    var AddressShippingModel = Backbone.Model.extend({
      // TODO move to account configuration
      urlRoot: pathname + "/account/api/v1/address-book/default-shipping/",
    });


    /**
     * Address Book management 
     */
    export default Backbone.View.extend({
        initialize: function () {

            this.defaultAddressBillingModel = new DefaultAddressBillingModel();
            this.defaultAddressShippingModel = new DefaultAddressShippingModel();

            this.addressBillingModel = new AddressBillingModel();
            this.addressShippingModel = new AddressShippingModel();

            // Set default active address
            this.addressActive = {};
            _.each($('.active'), e => {
                if ($(e).hasClass('js-defautlBillingAddress')) {
                    this.addressActive.billing = $(e).parents('.js-postalContent').data('addressid');
                } else if ($(e).hasClass('js-defautlShippingAddress')) {
                    this.addressActive.shipping = $(e).parents('.js-postalContent').data('addressid') ||
                        $(e).parents('.js-relayContent').data('addressid');
                }
            });
        },

        events: {
            "click .js-defautlBillingAddress": "setDefaultBillingAddress",
            "click .js-defautlShippingAddress": "setDefaultShippingAddress",
            "click .js-removePostalAddress": "removePostalAddress",
            "click .js-removeRelayAddress": "removeRelayAddress"
        },

        setDefaultBillingAddress: function (e) {
            e.preventDefault();
            var currentTarget = $(e.currentTarget);

            this.defaultAddressBillingModel.save(
                {

                    id: currentTarget.parents('.js-postalContent').data("addressbookreference")
                },
                {
                    success: (model, response) => {
                        $('.js-defautlBillingAddress').removeClass('active');
                        currentTarget.addClass('active');
                        this.addressActive.billing = response.Id;
                        $('.js-account-billing-address .js-address').replaceWith(AccountAddressTemplate.render(response));
                        $('.js-account-billing-address .js-address-message').addClass('hide');
                    },
                    error: function () {
                      SharedDispatcher.trigger("flashmessage:show");
                    }
                });
        },

        setDefaultShippingAddress: function (e) {
            e.preventDefault();
            var currentTarget = $(e.currentTarget);
            this.defaultAddressShippingModel.save(
                {
                    id: currentTarget.parents('.js-postalContent').data("addressbookreference") ||
                    currentTarget.parents('.js-relayContent').data("addressbookreference")
                },
                {
                    success: (model, response) => {
                        $('.js-defautlShippingAddress').removeClass('active');
                        currentTarget.addClass('active');
                        this.addressActive.shipping = response.Id;
                        $('.js-account-shipping-address .js-address').replaceWith(AccountAddressTemplate.render(response));
                        $('.js-account-shipping-address .js-address-message').addClass('hide');
                    },
                    error: function () {
                      SharedDispatcher.trigger("flashmessage:show");
                    }
                });
        },

        removePostalAddress: function (e) {
            e.preventDefault();

            $.ajax({
                type: 'POST',
                headers: {
                    'X-HTTP-Method-Override': 'DELETE'
                },
                // TODO move to account configuration (as template URL)
                url: pathname + "/account/api/v1/address-book/settings/postal/delete/" + $(e.currentTarget).parents('.js-postalContent').data("addressbookreference"),
                contentType: 'application/json',
                success: res => {
                    //var currentAddressId = $(e.currentTarget).parents('.js-postalContent').data('addressid');
                    //$(e.currentTarget).parents('.js-postalContent').remove();

                    //if (currentAddressId === this.addressActive.billing) {
                    //    if ($($('.js-postalContent')[0]).length) {
                    //        $($('.js-postalContent')[0]).find('.js-defautlBillingAddress').trigger('click');
                    //    } else {
                    //        $('.js-account-billing-address .js-address').empty();
                    //        $('.js-account-billing-address .js-address-message').removeClass('hide');
                    //        $('.js-address-postal-message').removeClass('hide');
                    //        $('.js-address-postal-arrow').addClass('hide');
                    //    }
                    //}
                    //if (currentAddressId === this.addressActive.shipping) {
                    //    if ($($('.js-postalContent')[0]).length) {
                    //        $($('.js-postalContent')[0]).find('.js-defautlShippingAddress').trigger('click');
                    //    } else {
                    //        $('.js-account-shipping-address .js-address').empty();
                    //        $('.js-account-shipping-address .js-address-message').removeClass('hide');
                    //        $('.js-address-postal-message').removeClass('hide');
                    //        $('.js-address-postal-arrow').addClass('hide');
                    //    }
                    //}

                    var addressurl = $(e.currentTarget).data('url'); 
                    window.location.href = addressurl;

                }
            });


        },

        removeRelayAddress: function (e) {
            e.preventDefault();


            $.ajax({
                type: 'POST',
                headers: {
                    'X-HTTP-Method-Override': 'DELETE'
                },
                // TODO move to account configuration (as template URL)
                url: pathname + "/account/api/v1/address-book/settings/relay/delete/" + $(e.currentTarget).parents('.js-relayContent').data("addressid"),
                contentType: 'application/json',
                success: res => {
                    var currentAddressId = $(e.currentTarget).parents('.js-relayContent').data('addressid');
                    $(e.currentTarget).parents('.js-relayContent').remove();

                    if (currentAddressId === this.addressActive.shipping) {
                        if ($($('.js-postalContent')[0]).length) {
                            $($('.js-postalContent')[0]).find('.js-defautlShippingAddress').trigger('click');
                            $('.js-address-relay-message').removeClass('hide');
                            $('.js-address-relay-arrow').addClass('hide');
                        } else {
                            $('.js-account-shipping-address .js-address').empty();
                            $('.js-account-shipping-address .js-address-message').removeClass('hide');
                        }
                    }

                    if ($('.js-relayContent')) {
                        $('.js-address-relay-message').removeClass('hide');
                        $('.js-address-relay-arrow').addClass('hide');
                    }
                }
            });

        }

    });
